import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

const StatementAllocationBlock = ({
  stmtAllocTitle,
  isEdit,
  beneficialOwner,
  allowLayerAllocationChange,
  details,
  onIncomeAllocationChange,
  displayStatementAllocationValue,
  disabled,
  formatPercentage
}) => {
  const [inputValue, setInputValue] = useState(formatPercentage(details.statementAllocation, 8) ?? '');

  const handleBlur = () => {
    onIncomeAllocationChange(inputValue);
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  useEffect(() => {
    setInputValue(formatPercentage(details.statementAllocation, 8) ?? '');
  }, [details.statementAllocation, formatPercentage]);

  return (/* Statement Allocations */
    <div className="allocation-group">
      <div className="allocation-title">
        {stmtAllocTitle}
      </div>
      {(!isEdit) && <div
        className="allocation-value"
        data-testid="label-allocation-value"
      >
        {displayStatementAllocationValue(beneficialOwner)} %
        </div>}
      {((isEdit && allowLayerAllocationChange) || (isEdit)) && <div
        className="allocation-input"
      >
        <input
          type="number"
          value={ inputValue }
          onChange={ handleChange }
          onBlur={ handleBlur }
          data-testid="field-allocation-value"
          disabled={ disabled }
        />
        <span className="percentage-symbol"> %</span>
        </div>}
    </div>);
};

StatementAllocationBlock.propTypes = {
  stmtAllocTitle: PropTypes.string.isRequired,
  isEdit: PropTypes.bool.isRequired,
  beneficialOwner: PropTypes.shape().isRequired,
  allowLayerAllocationChange: PropTypes.bool.isRequired,
  details: PropTypes.shape({
    statementAllocation: PropTypes.number
  }).isRequired,
  onIncomeAllocationChange: PropTypes.func.isRequired,
  displayStatementAllocationValue: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  formatPercentage: PropTypes.func.isRequired
};

export default StatementAllocationBlock;
